import React, { useState } from "react";
import image11 from "../../../assests/image11.jpg";
import Tooltip from "@mui/material/Tooltip";


import { Bookmark, LockKeyhole, RefreshCw, Link } from "lucide-react";
const businessFunctionOptions = [
    { value: "mw", label: "MW" },
    { value: "health", label: "Health" },
    { value: "immersive", label: "Immersive" }
];
const getBusinessFunctionLabel = (value) => {
    const option = businessFunctionOptions.find(
        (item) => item.value === value
    );
    return option ? option.label : "NA";
};

const ReportCard = ({ report, onShareReport, onViewReport }) => {
    const [showCopied, setShowCopied] = useState(false);
    const handleCopy = () => {
        if (!report?.report_link) return;

        navigator.clipboard.writeText(report.report_link);
        setShowCopied(true);

        setTimeout(() => {
            setShowCopied(false);
        }, 2000);
    };



    const getStatusStyle = (status) => {
        if (status?.toLowerCase() === "pending") {
            return "bg-blue-600 hover:bg-blue-700 text-white";
        }
        return "bg-blue-600 hover:bg-blue-700 text-white";
    };

    return (
        <div className="relative pt-12 mb-8">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 z-10">
                <img
                    src={image11}
                    alt="icon"
                    className="h-[78px] w-auto"
                />

            </div>

            {/* Card Container */}
            <div className={`bg-white rounded-3xl border-2  hover:shadow-lg transition-all duration-200 overflow-visible`}>
                {/* Card Header */}
                <div className="pt-4 px-3 pb-2">
                    <div className="flex items-end justify-end mb-4">
                        {/* Bookmark Icon */}
                        <button className="text-gray-300 hover:text-gray-500 transition-colors">
                            <Bookmark size={20} className="text-gray-600" />
                        </button>
                    </div>

                    {/* Title */}
                    <h3 className="text-center text-lg font-bold text-gray-900 mb-2 leading-tight">{report.product_name}</h3>


                    <div className="flex justify-between gap-1 w-full">
                        <div className="flex flex-wrap justify-center gap-2 mb-2 bg-blue-100 p-2 rounded-lg flex-1">
                            <span className="inline-block text-blue-600 text-xs font-medium">
                                {report?.report_type || "NA"}
                            </span>
                        </div>

                        <div className="flex flex-wrap justify-center gap-2 mb-2 bg-blue-100 p-2 rounded-lg flex-1">
                            <span className="inline-block text-blue-600 text-xs font-medium">
                                {getBusinessFunctionLabel(report?.business_function)}
                            </span>
                        </div>

                    </div>


                    {/* --- Seperate */}
                    <div
                        className="h-[3px] mb-2 w-[calc(100%+16px)] -ml-2"
                        style={{
                            backgroundImage:
                                "repeating-linear-gradient(to right, #9ca3af 0 10px, transparent 10px 18px)",
                        }}
                    />



                    {/* Last Refreshed */}
                    {report.last_modified && (
                        <div className="flex items-center justify-start gap-4 text-sm text-gray-400 mb-2">
                            <RefreshCw size={18} />
                            Last refreshed, {new Date(report.last_modified).toISOString().split("T")[0]}
                        </div>

                    )}


                    <div className="bg-blue-100 rounded-lg p-4 mb-2 h-[80px]">
                        <Tooltip
                            title={
                                report?.report_objective && report.report_objective !== "NA"
                                    ? report.report_objective
                                    : "Description not available"
                            }
                            arrow
                        >
                            <p className="text-gray-700 text-sm leading-relaxed font-semibold cursor-pointer">
                                {report?.report_objective && report.report_objective !== "NA"
                                    ? report.report_objective.length > 70
                                        ? `${report.report_objective.slice(0, 70)}...`
                                        : report.report_objective
                                    : "Description not available"}
                            </p>
                        </Tooltip>
                    </div>




                    {/* Category */}
                    {report.market && (
                        <div className="bg-purple-100 rounded-lg p-3 mb-3 py-2">
                            <p className="text-purple-800 font-medium text-sm"> Market : {report.region}</p>
                        </div>
                    )}

                    {/* Metrics/Keywords */}
                    {report?.tags && (
                        <div className="flex flex-wrap gap-[10px] mb-1 ml-2 h-[80px]">
                            {report.tags.split(",").map((tag, index) => (
                                <div
                                    key={index}
                                    className="text-orange-500 text-sm font-medium"
                                >
                                    {tag.trim()}
                                </div>
                            ))}
                        </div>
                    )}


                </div>

                {/* Card Footer */}
                <div className="px-3 pb-5 space-y-3 w-full">{/* Share Report Button */}
                    {showCopied && (
                        <div className="fixed top-[70px] right-4 bg-black text-white px-4 py-2 rounded-lg shadow-lg z-50 
                  animate-slide-in">
                            Link copied to clipboard
                        </div>
                    )}


                    <button
                        onClick={handleCopy}
                        className="w-full flex items-center justify-start gap-2 px-4 py-2 text-black text-md font-medium rounded-lg bg-gray-100"
                    >
                        <Link className="h-4" />
                        Share Report
                    </button>


                    {/* View Report / Status Button */}
                    <button
                        className={`w-full flex items-center justify-start gap-2 px-4 py-2 rounded-2xl font-medium transition-colors ${getStatusStyle(
                            report.status
                        )}`}
                    >
                        <LockKeyhole className="h-6 text-white" />
                        Subscribe
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReportCard;
